export const dateFormat = () => {
    const d = new Date()
    const dformat = [
        d.getFullYear(),
        (d.getMonth() + 1)
            .toString()
            .padStart(2, '0'),
        d.getDate()
            .toString()
            .padStart(2, '0')
    ].join('-')

    return dformat
}

export const dateFormatter = (date) => {
    console.log(date)
    const d = new Date(date)
    const dformat = [
        d.getFullYear(),
        (d.getMonth() + 1)
            .toString()
            .padStart(2, '0'),
        d.getDate()
            .toString()
            .padStart(2, '0')
    ].join('-')

    return dformat
}

export const myCurrentDateTime = () => {
    const d = new Date()
    const dformat = [
        d.getFullYear(),
        (d.getMonth() + 1)
            .toString()
            .padStart(2, '0'),
        d.getDate()
            .toString()
            .padStart(2, '0')
    ].join('-') + 'T' +
        [
            d.getHours()
                .toString()
                .padStart(2, '0'),
            d.getMinutes()
                .toString()
                .padStart(2, '0'),
            d.getSeconds()
                .toString()
                .padStart(2, '0')
        ].join(':');

    return dformat
}

export const datetimeFormat = (date) => {
    const d = new Date(date)
    const dformat = [
        d.getFullYear(),
        (d.getMonth() + 1)
            .toString()
            .padStart(2, '0'),
        d.getDate()
            .toString()
            .padStart(2, '0')
    ].join('-') + 'T' +
        [
            d.getHours()
                .toString()
                .padStart(2, '0'),
            d.getMinutes()
                .toString()
                .padStart(2, '0'),
            d.getSeconds()
                .toString()
                .padStart(2, '0')
        ].join(':');

    return dformat
}

export const getHours = (date = new Date()) => {
    const split = date.toString().split(' ')

    return split[1]
}

export const getYearFromDate = (date) => {
    let split = date.split(' ')
    let day = split[0].split('-')

    const year = day[0]
    return year.toString()
}